import { ErrorCode } from "./ErrorCodes";

export class SystemError extends Error {
    private _code:ErrorCode;
    private _subErrors:SystemError[];

    constructor(code:ErrorCode, message:string, subErrors?:SystemError[]) {
		super(message)
        this.code = code;
        this.message = message;
        this.subErrors = subErrors;
    }


	public get code(): ErrorCode {
		return this._code;
	}

	public set code(value: ErrorCode) {
		this._code = value;
	}

	public get subErrors(): SystemError[] {
		return this._subErrors;
	}

	public set subErrors(value: SystemError[]) {
		this._subErrors = value;
	}
    
}


// WEBPACK FOOTER //
// ./src/app/shared/models/SystemError.ts